import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { styled } from '@mui/material/styles';
import * as empApi from '../../lib/api/employee';

import {
  Grid,
  Paper,
  TextField,
  Box,
  Skeleton,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormHelperText,
  FormGroup,
  Checkbox,
} from '@mui/material';
import 'dayjs/locale/ko'; 

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';

import * as dayjs from 'dayjs'
import HrGradeSelectbox from '../common/form/selectbox/HrGradeSelectbox';
import HrPolicySelectbox from '../common/form/selectbox/HrPolicySelectbox';
import HrDptSelectbox from '../common/form/selectbox/HrDptSelectbox';
import EmpFileUploadContainer from '../../containers/common/fileupload/EmpFileUploadContainer';

import UserRoleMultiCheckbox from '../common/form/checkbox/UserRoleMultiCheckbox';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const authFilter = {
  blcCd: 'AUTH',
  mlcCd: 'USR',
  useYn: 'Y',
};

const EmployeeForm = ({ employee, formik }) => {
  const [entryDt, setEntryDt] = useState(null);
  // 사번 중복 체크(onBlur) - 최종 검증은 저장 시 백엔드가 다시 한다. 2026-10-23 결정.
  const [usrNoCheck, setUsrNoCheck] = useState({ checking: false, error: null });

  useEffect(() => {
    if (employee) {
      if (employee.entryDt) setEntryDt(dayjs(employee.entryDt));
    }
    // 수정 대상이 바뀌면(다른 사원 편집으로 이동 등) 이전 체크 결과를 지운다.
    setUsrNoCheck({ checking: false, error: null });
  }, [employee]);

  const handleBlurUsrNo = async (e) => {
    formik.handleBlur(e);
    const usrNo = formik.values.usrNo ? formik.values.usrNo.trim() : '';
    if (!usrNo) {
      setUsrNoCheck({ checking: false, error: null });
      return;
    }
    setUsrNoCheck({ checking: true, error: null });
    try {
      const res = await empApi.checkUsrNo(usrNo, employee?.usrUuid);
      const { available, ownerName } = res.data;
      setUsrNoCheck({
        checking: false,
        error: available
          ? null
          : `이미 사용 중인 사번입니다: ${usrNo} (${ownerName})`,
      });
    } catch (err) {
      // 체크 자체가 실패해도(네트워크 등) 폼 사용을 막지 않는다 - 저장 시 백엔드가 최종 검증.
      setUsrNoCheck({ checking: false, error: null });
    }
  };

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  const handleChangePrivilege = (item, isCheck) => {
    const old_list = [...formik.values.privilegeList];

    const newValue = {
      tgtUuid: employee?.usrUuid,
      tgtTyp: item?.slcCd,
      authTyp: item?.revVal2,
      authNm: item?.revVal1,
      authYn: isCheck ? 'Y' : 'N',
    };
    // 기존에 있는가? 있으면 업데이트, 없으면 추가.
    const findIndex = _.findIndex(
      old_list,
      (ol) => ol.authTyp === newValue?.authTyp,
    );
    console.log(findIndex, 'findIndex');
    if (findIndex > -1) {
      old_list[findIndex] = { ...old_list[findIndex], ...newValue };
    } else {
      old_list.push(newValue);
    }

    formik.setFieldValue('privilegeList', old_list);

    console.log(old_list, 'old_list');
  };

  return (
    <>
      <Paper
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 1,
          p: 2,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid container spacing={1}>
          {employee && (
            <Grid xs={3} item textAlign="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignContent: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mb: 1,
                }}
              >
                {employee && employee.profileImg ? (
                  <Img
                    style={{
                      width: 200,
                      height: 170,
                    }}
                    alt={employee.usrNm}
                    src={employee.profileImg}
                  />
                ) : (
                  <Skeleton
                    variant="rectangular"
                    width={200}
                    height={170}
                    animation={false}
                  />
                )}
              </Box>
              {/* <FileDropZone fileTyp="profile" fileAttrVal1={user.usrUuid} /> */}
              <EmpFileUploadContainer
                fileTyp="profile"
                fileAttrVal1={employee.usrUuid}
              />
            </Grid>
          )}
          <Grid
            item
            xs={employee ? 9 : 12}
            sx={{ flexGrow: 1 }}
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={2}>
                <TextField
                  margin="normal"
                  required
                  variant="outlined"
                  fullWidth
                  id="usrNo"
                  name="usrNo"
                  label="사번"
                  value={formik.values.usrNo}
                  onChange={(e) => {
                    if (usrNoCheck.error) {
                      setUsrNoCheck({ checking: false, error: null });
                    }
                    formik.handleChange(e);
                  }}
                  onBlur={handleBlurUsrNo}
                  error={
                    (formik.touched.usrNo && Boolean(formik.errors.usrNo)) ||
                    Boolean(usrNoCheck.error)
                  }
                  helperText={
                    (formik.touched.usrNo && formik.errors.usrNo) ||
                    usrNoCheck.error
                  }
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  margin="normal"
                  required
                  variant="outlined"
                  fullWidth
                  id="usrNm"
                  name="usrNm"
                  label="이름"
                  value={formik.values.usrNm}
                  onChange={formik.handleChange}
                  error={formik.touched.usrNm && Boolean(formik.errors.usrNm)}
                  helperText={formik.touched.usrNm && formik.errors.usrNm}
                />
              </Grid>
              <Grid item xs={4}>
                <HrDptSelectbox
                  formik={formik}
                  name="dptUuid"
                  label="부서"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={3}>
                <HrGradeSelectbox
                  formik={formik}
                  name="gradeUuid"
                  label="직급"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            {!employee && (
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={1}
              >
                <Grid item xs={6}>
                  <TextField
                    type="password"
                    margin="normal"
                    required
                    variant="outlined"
                    fullWidth
                    autoComplete="current-password"
                    id="password"
                    name="password"
                    label="비밀번호"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.password && Boolean(formik.errors.password)
                    }
                    helperText={
                      formik.touched.password && formik.errors.password
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    type="password"
                    margin="normal"
                    required
                    variant="outlined"
                    fullWidth
                    autoComplete="current-confirmPassword"
                    id="confirmPassword"
                    name="confirmPassword"
                    label="비밀번호 확인"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.confirmPassword &&
                      Boolean(formik.errors.confirmPassword)
                    }
                    helperText={
                      formik.touched.confirmPassword &&
                      formik.errors.confirmPassword
                    }
                  />
                </Grid>
              </Grid>
            )}
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={3}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="telNo"
                  name="telNo"
                  label="연락처"
                  value={formik.values.telNo}
                  onChange={formik.handleChange}
                  error={formik.touched.telNo && Boolean(formik.errors.telNo)}
                  helperText={formik.touched.telNo && formik.errors.telNo}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="emlAddr"
                  name="emlAddr"
                  label="이메일"
                  value={formik.values.emlAddr}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.emlAddr && Boolean(formik.errors.emlAddr)
                  }
                  helperText={formik.touched.emlAddr && formik.errors.emlAddr}
                />
              </Grid>
              <Grid item xs={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko"
                >
                  <DatePicker
                    label="입사일"
                    format="YYYY-MM-DD"
                    mask={'____-__-__'}
                    id="entryDt"
                    name="entryDt"
                    value={dayjs(entryDt)}
                    onChange={(newValue) => {
                      setEntryDt(dayjs(newValue));
                      onChangeDate(dayjs(newValue), 'entryDt');
                    }}
                    slotProps={{
                      textField: {
                        margin: "normal",
                        variant: "outlined",
                        required: true,
                        fullWidth: true,
                        error:
                          formik.touched.entryDt &&
                          Boolean(formik.errors.entryDt),
                        helperText: formik.touched.entryDt && formik.errors.entryDt,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3}>
                <HrPolicySelectbox
                  formik={formik}
                  name="policyUuid"
                  label="직책"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
            
            </Grid>
            {/* <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={3}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="postAddrNm"
                  name="postAddrNm"
                  label="우편번호"
                  value={formik.values.postAddrNm}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.postAddrNm &&
                    Boolean(formik.errors.postAddrNm)
                  }
                  helperText={
                    formik.touched.postAddrNm && formik.errors.postAddrNm
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="postAddrTxt"
                  name="postAddrTxt"
                  label="주소"
                  value={formik.values.postAddrTxt}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.postAddrTxt &&
                    Boolean(formik.errors.postAddrTxt)
                  }
                  helperText={
                    formik.touched.postAddrTxt && formik.errors.postAddrTxt
                  }
                />
              </Grid>
            </Grid> */}
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={9}>
                <UserRoleMultiCheckbox
                  label="권한"
                  name="privilegeList"
                  checkedList={formik?.values?.privilegeList}
                  onChangeChecked={handleChangePrivilege}
                />
              </Grid>
              <Grid item xs={3}>
                <FormGroup>
                  <FormControlLabel
                    id="useYn"
                    name="useYn"
                    label="사용"
                    control={
                      <Checkbox
                        checked={formik.values.useYn}
                        defaultChecked
                        onChange={(event) =>
                          formik.setFieldValue('useYn', event.target.checked)
                        }
                      />
                    }
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{ px: 1 }}
          >
            <Grid item xs={12}>
              <TextField
                margin="normal"
                variant="outlined"
                fullWidth
                id="infoDesc"
                name="infoDesc"
                label="참고사항"
                multiline
                rows={5}
                value={formik.values.infoDesc}
                onChange={formik.handleChange}
                error={
                  formik.touched.infoDesc && Boolean(formik.errors.infoDesc)
                }
                helperText={formik.touched.infoDesc && formik.errors.infoDesc}
              />
            </Grid>
          </Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 1,
          }}
        >
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
      </Paper>
    </>
  );
};

export default EmployeeForm;
